var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox-group',{attrs:{"options":_vm.displayOptions,"stacked":"","size":"lg"}})}
var staticRenderFns = []

export { render, staticRenderFns }